import { render, staticRenderFns } from "./SectionSeasons.vue?vue&type=template&id=1ddd9564&scoped=true&"
import script from "./SectionSeasons.vue?vue&type=script&lang=js&"
export * from "./SectionSeasons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddd9564",
  null
  
)

export default component.exports